<div>
  <form [formGroup]="entityBranchListForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <table mat-table matSort [dataSource]="entityBranchDataSource" (matSortChange)="sortData($event)" [ngClass]="{'row-disabled':disableTable}">
          <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef class="header">
              <div class="sorting_header">
                <span mat-sort-header>Branch Code</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">{{element.code}}</td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="header">
              <div class="sorting_header">
                <span mat-sort-header>Branch Name</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">{{element.name}}</td>
          </ng-container>
          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef class="header">
              <div class="sorting_header">
                <span mat-sort-header>Branch Location</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">{{element.countryName}}</td>
          </ng-container>
          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef class="header">
              <div class="sorting_header">
                <span mat-sort-header>Branch City</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">{{element.cityName}}</td>
          </ng-container>
          <ng-container matColumnDef="sez">
            <th mat-header-cell *matHeaderCellDef class="header">
              <div class="sorting_header">
                <span mat-sort-header>SEZ</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon style="cursor: pointer;" (click)="openSEZ(element.id)" [ngClass]="{'row-disabled':element.submittedForApproval}">open_in_new</mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef class="header">
              <div class="sorting_header">
                <span mat-sort-header>Branch Details</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon  class="icon-margin" (click)="openBranchDetails(element.id)">open_in_new</mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="gst">
            <th mat-header-cell *matHeaderCellDef class="header">
              <div class="sorting_header">
                <span mat-sort-header>Branch GST</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon  class="icon-margin" (click)="openGST(element.id)" [ngClass]="{'row-disabled':element.submittedForApproval}">open_in_new</mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="contact">
            <th mat-header-cell *matHeaderCellDef class="header">
              <div class="sorting_header">
                <span mat-sort-header>Branch Contact</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon  class="icon-margin" (click)="openContact(element)" [ngClass]="{'row-disabled':element.submittedForApproval}">open_in_new</mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="kyc">
            <th mat-header-cell *matHeaderCellDef class="header">
              <div class="sorting_header">
                <span mat-sort-header>Branch KYC</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon class="icon-margin" (click)="openKYC(element.id)" [ngClass]="{'row-disabled':element.submittedForApproval}">open_in_new</mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="deactivate">
            <th mat-header-cell *matHeaderCellDef class="header">
              <div class="sorting_header">
                <span mat-sort-header>Deactivate/Reactivate</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-hint style="color: red;">{{element.message}}</mat-hint>
              @if (element.showDeactivateToggle) {
                <mat-slide-toggle (change)="openDeactivateForm($event,element.id)"
                [(ngModel)]="element.checkedDeactivate" [ngModelOptions]="{standalone: true}">Deactivate</mat-slide-toggle>
              }
              @if (element.showReactivateToggle) {
                <mat-slide-toggle (change)="openReactivateForm($event,element.id)" [(ngModel)]="checked"
                [(ngModel)]="element.checkedReactivate" [ngModelOptions]="{standalone: true}" >Reactivate</mat-slide-toggle>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="header">
              <div class="sorting_header">
                <span mat-sort-header>Branch Status</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let element">{{element.status}}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="entityBranchColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: entityBranchColumns;"
          [ngStyle]="row.excluded==true && {'background-color': 'lightgrey'}"></tr>
        </table>
      </mat-card-content>
    </mat-card>
    @if (!buttonHidden) {
      <mat-card-actions>
        <button mat-button color="cancel" (click)="cancel()">CANCEL</button>
      </mat-card-actions>
    }
  </form>
</div>